import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import ContactForm from '@/components/common/ContactForm';

const FinalCTASection = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-900">
            {t('salescockpitPage.callToAction.title')}
          </h2>
          <p className="text-xl text-gray-700 mb-8">
            {t('salescockpitPage.callToAction.description')}
          </p>
        </div>

        <ContactForm />
        
        <form className="hidden" action="https://getform.io/f/avrwvgya" method="POST">
          <input type="hidden" name="_gotcha" />
          <input type="hidden" name="form-name" value="salescockpit-contact" />
          <input type="hidden" name="source" value="salescockpit-page" />
        </form>
      </div>
    </section>
  );
};

export default FinalCTASection; 